<template>
  <div class="status">
    <span
      class="icon"
      :style="{backgroundColor: scope.row.status === 1 ? '#52c41a':'#bfbfbf'}"
    ></span>
    {{ scope.row.status === 1 ? '已完成' : '未完成' }}
  </div>
</template>
<script>
export default {
  props: {
    scope: {
      type: Object,
      default () {
        return {}
      }
    }
  }
}
</script>
<style lang="scss" scoped>
  .status {
    display: flex;
    align-items: center;
    font-size: 13px;
    color: #595959;

    .icon {
      display: block;
      width: 6px;
      height: 6px;
      border-radius: 50%;
      margin-right: 8px;
    }
  }
</style>
